import { Injectable, inject } from '@angular/core';
import { OperationTypeEnum } from '@data-access/bulk-operations-api';
import { FeatureFlagService } from '@feature-flag';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
@UntilDestroy()
export class DisabledOperationService {
  private featureFlagService = inject(FeatureFlagService);

  private _disabledOperations = new BehaviorSubject<{ [key: string]: boolean }>({});

  constructor() {
    this.getFeatureToggles();
  }

  getDisabledOperations(): Observable<{ [key: string]: boolean }> {
    return this._disabledOperations.asObservable();
  }

  private getFeatureToggles(): void {
    combineLatest([
      this.featureFlagService.getFlagValue('disable-post-for-employee'),
      this.featureFlagService.getFlagValue('disable-post-for-transaction'),
      this.featureFlagService.getFlagValue('disable-post-for-calendar'),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([employeeToggle, transactionToggle, calendarToggle]) => {
        this._disabledOperations.next({
          [OperationTypeEnum.SalaryUpdateV2]: employeeToggle,
          [OperationTypeEnum.EndFixedTransactions]: transactionToggle,
          [OperationTypeEnum.VacationBalanceImport]: calendarToggle,
          [OperationTypeEnum.PositionTagsUpdate]: employeeToggle,
          [OperationTypeEnum.AbsenceRegistrationImport]: calendarToggle,
          [OperationTypeEnum.EditPositionEndDates]: employeeToggle,
          [OperationTypeEnum.AssignUser]: employeeToggle,
          [OperationTypeEnum.ChangeManager]: employeeToggle,
          [OperationTypeEnum.PayRateUpdate]: employeeToggle,
          [OperationTypeEnum.AssignCostUnits]: employeeToggle,
          [OperationTypeEnum.AssignUnion]: employeeToggle,
          [OperationTypeEnum.EditFixedTransactions]: transactionToggle,
        });
      });
  }
}
